import { Star, Quote } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, SectionKicker } from "./Reveal";

export const Testimonials = () => {
  const { t } = useLang();
  const te = t.testimonials;

  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <SectionKicker>{te.kicker}</SectionKicker>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            {te.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {te.items.map((item, i) => (
            <Reveal key={i} delay={(i % 2) * 0.08}>
              <figure
                data-testid={`testimonial-${i}`}
                className="relative h-full rounded-2xl border border-white/10 bg-[#0d0d0d] p-7 transition-all hover:border-brand/40"
              >
                <Quote className="absolute top-6 right-6 h-8 w-8 text-brand/20" />
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-brand text-brand" />
                  ))}
                </div>
                <blockquote className="mt-4 text-zinc-300 leading-relaxed">
                  “{item.text}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full bg-brand/15 grid place-items-center font-heading font-bold text-brand text-sm">
                    {item.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-heading font-semibold text-white text-sm">
                      {item.name}
                    </div>
                    <div className="text-xs text-zinc-400">{item.role}</div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
